/**
 * Thème ECharts aligné sur le design system Tailwind (gris / bleu primaire).
 * Indices : 0 barre principale, 1 ligne HT, 2 barre stack, 3 ligne HT extra,
 * 4 ligne TEC, 5 ligne TEC write-off.
 */
export const u340xEchartsTheme = {
  color: ['#2563eb', '#059669', '#93c5fd', '#6ee7b7', '#d97706', '#fbbf24'],
  textColor: '#374151',
  mutedTextColor: '#6b7280',
  axisLineColor: '#d1d5db',
  splitLineColor: '#e5e7eb',
  tooltipBg: '#ffffff',
  tooltipBorder: '#e5e7eb',
  fontFamily: 'inherit',
} as const;

/**
 * Marges (px) du plot dual-axe (`grid` avec `containLabel: false`).
 * Définit la zone des barres, à l'intérieur des libellés d'axes Y.
 */
export const u340xEchartsPlotInset = {
  leftPx: 60,
  rightPx: 72,
  topPx: 32,
  bottomPx: 56,
} as const;

/**
 * Inset horizontal (px) de la timeline standalone. Calé non pas sur la zone
 * des barres mais sur le bord extérieur des *chiffres* d'axes Y : la piste
 * démarre au niveau du chiffre de gauche et finit au niveau de celui de droite.
 * Valeurs mesurées sur le rendu ECharts (labels « 1 800 » / « 150 000 $ »).
 */
export const u340xTimelineInset = {
  leftPx: 28,
  rightPx: 20,
} as const;

export type U340xEchartsTheme = typeof u340xEchartsTheme;
